import {
  getBookingManagerListApi,
  getBookingManagerDetailApi,
  getLockingManagerListApi,
  getLockingManagerDetailApi,
  getLockingManagerStatisticApi,
  getTtkqManagerListApi,
  getTtkqManagerDetailApi,
  getSalesContractManagerListApi,
  getSalesContractManagerDetailApi,
  getSalesContractManagerStatisticApi,
} from "../../../api/sellManager.api";
import { appImages } from "../../../assets/appicons";

// =============================================================
// Cấu hình danh sách/chi tiết giao dịch quản lý theo loại.
// Nhãn, thẻ tổng và các dòng trong card khớp đúng từng màn của app:
//   management/booking | locking | sales-contract | ttkq
// =============================================================

// Mã căn hộ hiển thị trên tiêu đề card (mỗi loại lấy từ nhánh khác nhau).
const bookingApartment = (i) => i?.apartment?.code || "";
const lockingApartment = (i) => i?.apartment?.code || "";
const contractApartment = (i) => i?.locking?.apartment?.code || i?.ttkq?.locking?.apartment?.code || "";
const ttkqApartment = (i) => i?.locking?.apartment?.code || "";

export const SELL_TYPES = {
  booking: {
    title: "Booking",
    detailTitle: "Chi tiết đơn đăng ký booking",
    listTitle: "Danh sách booking",
    listApi: getBookingManagerListApi,
    detailApi: getBookingManagerDetailApi,
    summary: { text: "TỔNG SỐ BOOKING", kind: "count" },
    apartmentCode: bookingApartment,
    dateField: "bookingTime",
    historyKey: "bookingId",
    rows: [
      { label: "Nhân viên tạo", path: "booker.fullName" },
      { label: "Số tiền đặt cọc", path: "price", format: "money", highlight: true },
      { label: "Thời gian đặt cọc", path: "bookingTime", format: "date" },
      { label: "Khách hàng", path: "customer.name" },
    ],
  },
  locking: {
    title: "Locking",
    detailTitle: "Chi tiết đơn đăng ký locking",
    listTitle: "Danh sách locking",
    listApi: getLockingManagerListApi,
    detailApi: getLockingManagerDetailApi,
    statisticApi: getLockingManagerStatisticApi,
    statKeys: { total: "total", price: "priceTotal", commission: "priceForCommissionTotal" },
    summary: { text: "TỔNG DANH SỐ BÁN HÀNG", kind: "money" },
    statCards: [
      {
        subTitle: "LOCKING",
        title: "Căn hộ đã giữ chỗ",
        from: "total",
        icon: appImages.icon_locking,
        bgColor: "#EDFDF5",
        textColor: "#2ABA82",
      },
      {
        subTitle: "ĐẶT CỌC",
        title: "Số tiền đã đặt cọc",
        from: "price",
        format: "short",
        icon: appImages.icon_total_commission,
        bgColor: "#FFF7ED",
        textColor: "#F57127",
      },
    ],
    apartmentCode: lockingApartment,
    dateField: "bookingTime",
    historyKey: "lockingId",
    rows: [
      { label: "Nhân viên tạo", path: "booker.fullName" },
      { label: "Số tiền đặt cọc", path: "price", format: "money", highlight: true },
      { label: "Thời gian đặt cọc", path: "bookingTime", format: "date" },
      { label: "Khách hàng", path: "customer.name" },
    ],
  },
  hdmb: {
    title: "Hợp đồng mua bán",
    detailTitle: "Chi tiết đơn đăng ký HDMB",
    listTitle: "Danh sách HDMB",
    listApi: getSalesContractManagerListApi,
    detailApi: getSalesContractManagerDetailApi,
    statisticApi: getSalesContractManagerStatisticApi,
    statKeys: { total: "total", price: "totalPrice", commission: "totalPriceForCommission" },
    summary: { text: "TỔNG DANH SỐ BÁN HÀNG", kind: "money" },
    statCards: [
      {
        subTitle: "HDMB",
        title: "Căn hộ đã giữ chỗ",
        from: "total",
        icon: appImages.icon_locking,
        bgColor: "#EDFDF5",
        textColor: "#2ABA82",
      },
      {
        subTitle: "ĐẶT CỌC",
        title: "Số tiền đã đặt cọc",
        from: "price",
        format: "short",
        icon: appImages.icon_total_commission,
        bgColor: "#FFF7ED",
        textColor: "#F57127",
      },
    ],
    apartmentCode: contractApartment,
    dateField: "time",
    historyKey: "salesContractId",
    rows: [
      { label: "Nhân viên tạo", path: "creator.fullName" },
      { label: "Số tiền đóng HDMB", path: "price", format: "money", highlight: true },
      { label: "Ngày ký HDMB", path: "time", format: "date" },
      { label: "Ngày đóng HDMB", path: "priceTime", format: "date" },
      { label: "Khách hàng", path: "customer.name" },
    ],
  },
  ttkq: {
    title: "TTKQ/VBTT/HĐTHNV",
    detailTitle: "Chi tiết đơn đăng ký TTKQ",
    listTitle: "Danh sách TTKQ",
    listApi: getTtkqManagerListApi,
    detailApi: getTtkqManagerDetailApi,
    summary: { text: "TỔNG SỐ TTKQ", kind: "count" },
    apartmentCode: ttkqApartment,
    dateField: "time",
    historyKey: "ttkqId",
    rows: [
      { label: "Nhân viên tạo", path: "creator.fullName" },
      { label: "Số tiền đóng TTKQ", path: "price", format: "money", highlight: true },
      { label: "Ngày ký TTKQ", path: "time", format: "date" },
      { label: "Ngày đóng TTKQ", path: "priceTime", format: "date" },
      { label: "Khách hàng", path: "customer.name" },
    ],
  },
};

// Trạng thái giao dịch (khớp BookingManagementListCard của app).
export const transactionStatusUi = (status) => {
  if (status === "REFUND") return { label: "HOÀN BOOKING", bg: "#DDEDFF", color: "#1277EB" };
  if (status === "REJECTRETURNREQUEST") return { label: "TỪ CHỐI HOÀNG BOOKING", bg: "#FFF1F0", color: "#E5484D" };
  if (status === "PENDINGRETURNREQUEST") return { label: "ĐANG CHỜ HOÀN BOOKING", bg: "#FFF7E8", color: "#F79D0D" };
  if (status === "EDITING") return { label: "YÊU CẦU CHỈNH SỬA", bg: "#FFF7E8", color: "#F79D0D" };
  if (status === "APPROVED") return { label: "ĐÃ DUYỆT", bg: "#E9FFF4", color: "#0BA859" };
  if (status === "REJECTED") return { label: "TỪ CHỐI", bg: "#FFF1F0", color: "#E5484D" };
  return { label: "ĐANG CHỜ DUYỆT", bg: "#FFF7E8", color: "#F79D0D" };
};

export const TRANSACTION_STATUS_OPTIONS = [
  { key: "ALL", label: "Tất cả" },
  { key: "NEW", label: "Đang chờ duyệt" },
  { key: "APPROVED", label: "Đã duyệt" },
  { key: "REJECTED", label: "Từ chối" },
  { key: "EDITING", label: "Yêu cầu chỉnh sửa" },
  { key: "PENDINGRETURNREQUEST", label: "Đang chờ hoàn booking" },
  { key: "REFUND", label: "Hoàn booking" },
  { key: "REJECTRETURNREQUEST", label: "Từ chối hoàn booking" },
];

export const SELL_SORT_OPTIONS = [
  { key: "NEWEST", label: "Mới đến cũ", sortBy: "createdAt", sortOrder: "desc" },
  { key: "OLDEST", label: "Cũ đến mới", sortBy: "createdAt", sortOrder: "asc" },
];

export const getByPath = (obj, path) =>
  path.split(".").reduce((acc, key) => (acc == null ? acc : acc[key]), obj);
